import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import addClass from '@opten/dom/add-class';
import removeClass from '@opten/dom/remove-class';
import hasClass from '@opten/dom/has-class';

@Component({ className: 'js-form__field__input', observe: true })
export class InputFieldsFilled implements OnInit {
	constructor(private _element: HTMLInputElement | HTMLSelectElement) {}

	onInit(): void {
		if (hasClass(this._element, 'js-select') || hasClass(this._element, 'js-location__select')) {
			// todo: @SelfRef(Select)?
			// todo: we cannot use that, we don't know when initialized
			/*const select = document.querySelector(
                `[data-select='${this._element.id}']`
            ) as HTMLSelectElement;*/
			if (this._element.parentElement) {
				const select = this._element.parentElement.getElementsByTagName('select')[0];

				if (select) {
					// todo: somehow the select is too slow
					// when we trigger change, because then it animates the label
					// so we attach extra events...
					/*select.addEventListener('focus', () =>
                        addClass(this._element, '--is-filled')
                    );
                    select.addEventListener(
                        'blur',
                        () => select.value || this._checkValue(select)
                    );*/
					this._checkValue(select);
					select.addEventListener('change', () => this._checkValue(select));
				}
			}
		} else if (hasClass(this._element, 'js-datepicker-field')) {
			const hidden = this._element.parentElement.querySelector(
				`input[type='hidden'][name='${this._element.name.replace('_datepicker', '')}']`
			) as HTMLInputElement;

			if (hidden) {
				this._checkValue(hidden);
				hidden.addEventListener('change', () => this._checkValue(hidden));
			}
			this._element.addEventListener('change', () => this._checkValue());
		} else {
			this._checkValue();
			this._element.addEventListener('input', () => this._checkValue());
			this._element.addEventListener('change', () => this._checkValue());
		}
	}

	private _checkValue(element: HTMLInputElement | HTMLSelectElement = this._element) {
		if (element.tagName === 'select') {
			// todo: why?
			if ($ && $.validator && element.value) {
				$(element).valid();
			}
		}

		if (element.value) {
			addClass(this._element, '--is-filled');
		} else {
			removeClass(this._element, '--is-filled');
		}
	}
}
